import { PaymentModuleId } from '@foundation/apis/payments';
import { SupportedLanguage } from '@foundation/localization';

import { execGet, execPost } from '@/services/utils/RequestUtils';

import { WorldpayUrlApiResponse } from '../schemas';

export async function getCardUrl(
  paymentIntentId: string,
  accessToken: string,
  paymentInstrumentId?: string,
  locale = SupportedLanguage.English,
  telemetryConsent = false,
  paymentDataTypeId?: PaymentModuleId,
): Promise<string> {
  const searchParams = new URLSearchParams({
    tc: telemetryConsent.toString(),
    locale,
  });

  if (paymentInstrumentId !== undefined) {
    searchParams.append('paymentDataId', paymentInstrumentId.toString());
  }

  if (paymentDataTypeId !== undefined) {
    searchParams.append('paymentDataTypeId', paymentDataTypeId.toString());
  }

  const response = await execGet<WorldpayUrlApiResponse>(
    `paymentintent/${paymentIntentId}/worldpay/url?${searchParams.toString()}`,
    accessToken,
  );

  return response.redirectUrl;
}

export async function getManageCardUrl(
  legalEntityNumber: number,
  customerNumber: string,
  accessToken: string,
  moduleId: PaymentModuleId,
  locale = SupportedLanguage.English,
  telemetryConsent = false,
): Promise<string> {
  const response = await execPost<WorldpayUrlApiResponse>(
    `paymentinstruments`,
    {
      legalEntityNumber: legalEntityNumber,
      customerNumber: customerNumber,
      paymentDataTypeId: moduleId,
      locale: locale,
      tc: telemetryConsent,
    },
    accessToken,
  );

  return response.redirectUrl;
}

async function getLocalProviderUrl(
  paymentIntentId: string,
  accessToken: string,
  locale: SupportedLanguage,
  telemetryConsent = false,
  typeId: PaymentModuleId,
): Promise<string> {
  const searchParams = new URLSearchParams({
    tc: telemetryConsent.toString(),
    locale,
    paymentDataTypeId: typeId.toString(),
  });
  const response = await execGet<WorldpayUrlApiResponse>(
    `paymentintent/${paymentIntentId}/worldpay/url?${searchParams.toString()}`,
    accessToken,
  );

  return response.redirectUrl;
}

const getKlarnaUrl = async (
  paymentIntentId: string,
  accessToken: string,
  locale: SupportedLanguage = SupportedLanguage.English,
  telemetryConsent = false,
): Promise<string> =>
  getLocalProviderUrl(
    paymentIntentId,
    accessToken,
    locale,
    telemetryConsent,
    PaymentModuleId.WorldpayKlarna,
  );

const getBancontactUrl = async (
  paymentIntentId: string,
  accessToken: string,
  locale: SupportedLanguage = SupportedLanguage.English,
  telemetryConsent = false,
): Promise<string> =>
  getLocalProviderUrl(
    paymentIntentId,
    accessToken,
    locale,
    telemetryConsent,
    PaymentModuleId.WorldpayBancontact,
  );

const getIdealUrl = async (
  paymentIntentId: string,
  accessToken: string,
  locale: SupportedLanguage = SupportedLanguage.English,
  telemetryConsent = false,
): Promise<string> =>
  getLocalProviderUrl(
    paymentIntentId,
    accessToken,
    locale,
    telemetryConsent,
    PaymentModuleId.WorldpayIdeal,
  );

export { getKlarnaUrl, getBancontactUrl, getIdealUrl };
